// extracted by css-extract-rspack-plugin
export default {"hist":"UserPreview_hist__c1lTj","avatar":"UserPreview_avatar__ZRob9","avatarContainer":"UserPreview_avatarContainer__xwD2x","avatarSignature":"UserPreview_avatarSignature__KxTEz"};